import { required, Validator } from '@/entities/validation';
import { EntityItem } from './model';

export const validate: Validator<EntityItem> = record => [
  ...required(record.title, 'title'),
];
